<ng-container *ngIf="!!element">
  <div class="group">
    <mat-form-field class="minimize-height">
      <mat-label>{{'dynamicContent.startDate' | translate}}</mat-label>
      <input [(ngModel)]="element.startDate" [matDatepicker]="startPicker" [max]="element.endDate" matInput>
      <mat-datepicker-toggle [for]="startPicker" matPrefix>
        <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="minimize-height">
      <mat-label>{{'dynamicContent.startTime' | translate}}</mat-label>
      <input [(ngModel)]="element.startTime" matInput readonly>
      <button (click)="openTimePicker('startTime')" mat-icon-button matPrefix>
        <mat-icon>access_time</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div class="group">
    <mat-form-field class="minimize-height">
      <mat-label>{{'dynamicContent.endDate' | translate}}</mat-label>
      <input [(ngModel)]="element.endDate" [matDatepicker]="endPicker" [min]="element.startDate" matInput>
      <mat-datepicker-toggle [for]="endPicker" matPrefix>
        <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="minimize-height">
      <mat-label>{{'dynamicContent.endTime' | translate}}</mat-label>
      <input [(ngModel)]="element.endTime" matInput readonly>
      <button (click)="openTimePicker('endTime')" mat-icon-button matPrefix>
        <mat-icon>access_time</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <div class="button-right-container">
    <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{ 'general.save' | translate }}</button>
  </div>
</ng-container>
